var _path, _path2, _circle, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTramitacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Camada 1",
    viewBox: "0 0 32 32",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Prancheta 168") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96061,26.561l4.96533-.72144a2.44483,2.44483,0,0,0,1.37818-.69116L25.37785,9.07463A4.15964,4.15964,0,0,0,25.21574,3.038a4.31883,4.31883,0,0,0-5.88721.32055l-.772.772a.93614.93614,0,0,1-1.32373,0,2.99964,2.99964,0,0,0-4.24243,0L7.76774,9.35417A.99989.99989,0,0,0,9.18205,10.768L14.4047,5.54435a1.00276,1.00276,0,0,1,1.41407,0,.93649.93649,0,0,1-.00025,1.32422l-12.397,12.397A2.44547,2.44547,0,0,0,2.73039,20.644L2.009,25.6093A.83955.83955,0,0,0,2.96061,26.561Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.85173,22.67668a7.11559,7.11559,0,0,1-2.38038,1.94726,9.84611,9.84611,0,0,1-3.73632.38672c-.31006-.00586-.61817-.01172-.92286-.01172a1,1,0,1,0,0,2c.29249,0,.58838.00586.88575.01075a11.447,11.447,0,0,0,4.49756-.52149A8.38327,8.38327,0,0,0,20.174,24.19133v4.2539a1.52643,1.52643,0,0,0,2.60693,1.08008l2.22168-2.22168a4.39126,4.39126,0,0,1,3.84913-1.47754,1.00026,1.00026,0,0,0,.29589-1.97851,6.37456,6.37456,0,0,0-5.55957,2.042L22.174,27.30363V23.00676a1.5268,1.5268,0,0,0-2.60693-1.0791C19.32682,22.16691,19.0905,22.42082,18.85173,22.67668Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.17399,
    cy: 18.69304,
    r: 1.25
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 47,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Luiz Carvalho")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 52,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTramitacion);
export default __webpack_public_path__ + "static/media/tramitacion.ce64d017acd9d9c4e862f06d8a5c1475.svg";
export { ForwardRef as ReactComponent };